import React, { useState, useEffect, Suspense } from 'react';
import { BlogService } from './services/BlogService';
import { IArticleBlog } from '../../utils/ArticleInterface';
//import { BackgroundImageCard } from './components/BackgroundImageCard';
//import { Article } from './components/Article';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import Slider from "react-slick";
import { Typography, Grid, Box } from '@mui/material';
import { Link } from "react-router-dom";
import { Theme } from "@material-ui/core";
import TrendingFlatIcon from "@material-ui/icons/TrendingFlat";
import OptionMenu from './components/OptionMenu';
//import NavbarBlog from '../components/NavbarBlog';
import { PropagateLoader } from 'react-spinners';
import { Helmet } from 'react-helmet-async';
import AdSenseAd from '../components/AdSenseAd';
import LazySection from '../components/LazySection';

// Lazy Load Components
const BackgroundImageCard = React.lazy(() => import('./components/BackgroundImageCard'));
const Article = React.lazy(() => import('./components/Article'));
const NavbarBlog = React.lazy(() => import('../components/NavbarBlog'));

// Error Boundary Component
class ErrorBoundary extends React.Component {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  render() {
    if ((this.state as any).hasError) {
      return <div>Something went wrong while loading this component.</div>;
    }
    return this.props.children;
  }
}


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backgroundImageCard: {
      borderRadius: '20px', // Round edges for each card
      overflow: 'hidden',   // Ensure content doesn't overflow
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)', // Optional: add a shadow for effect
      position: 'relative', // Ensure slider controls are positioned relative to the card
    },
    sliderContainer: {
      position: 'relative',
      width: '100%', // Full width of the container
      overflow: 'hidden', // Prevent overflow outside the slider
      borderRadius: '20px',
      '& .slick-dots': {
        position: 'absolute',
        bottom: '20px', // Position dots inside the slider at the bottom
        left: '50%',
        transform: 'translateX(-50%)', // Center the dots horizontally
        display: 'flex !important', // Ensure dots display as flex for centering
        alignItems: 'center',
        justifyContent: 'center',
        '& li button:before': {
          fontSize: '10px', // Adjust dot size
          color: 'rgba(255, 255, 255, 0.8)', // Dot color (semi-transparent white)
        },
        '& li.slick-active button:before': {
          color: '#ffffff', // Active dot color (white)
        },
      },
    },
    sliderControls: {
      position: 'absolute',
      top: '50%', // Center controls vertically
      left: 0,
      right: 0,
      transform: 'translateY(-50%)', // Ensure vertical centering
      display: 'flex',
      justifyContent: 'space-between',
      zIndex: 2,  // Ensure slider controls are above the content
      width: '100%', // Match the width of the slider container
    },
    dots: {
      position: 'absolute',
      bottom: '10px',
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 2,  // Make sure dots are above the slider content
    },
    btnContainer: {
      display: "flex",
      justifyContent: "flex-end",
    },
    btn: {
      color: "#890608",
      fontSize: 14,
      textAlign: "right",
      textTransform: "capitalize",
      marginTop: 10,
      fontWeight: 'bold',
      textDecoration: 'none',  // Remove underline from the link
      '&:hover': {
        color: "#B5551B", // Change color on hover for a better effect
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: 12, // Slightly smaller font for mobile
        marginTop: 5,
      },
    },
    h1Title: {
      fontSize: '28px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 'bold',
      margin: '35px 0px 10px',
      paddingLeft: "16px"
    },
    h2Title: {
      fontSize: '16px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 'normal',
      margin: '2px 0px 25px',
      paddingLeft: "16px",
      paddingRight: "16px"
    },
    topContainer: {
      margin: 'auto', // Center the content
      [theme.breakpoints.up('md')]: {
        maxWidth: '83.33%', // Equivalent to 10/12 columns
      },
    },
    section: {      
      padding: '0px 16px', // Default padding for mobile
      [theme.breakpoints.up('md')]: {
        margin: '60px 130px', // Margin for larger screens
        padding: '0px 15px', // Padding for larger screens
      },
      borderBottom: '1px solid lightgrey',
      marginBottom: '20px',
    },
    sectionTitle: {
      fontSize: '24px',
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 'bold',
      margin: '20px 0px 5px',
      color: '#323232',
    },
    articleCards: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',  // To add space between the cards
      gap: '16px', // Space between cards
      [theme.breakpoints.up('md')]: {
        '& > div': {
          flexBasis: 'calc(33.333% - 16px)', // 3 cards in a row on large screens (minus gap space)
        },
      },
      [theme.breakpoints.down('sm')]: {
        '& > div': {
          flexBasis: '100%', // 1 card per row on smaller screens
        },
      },
    },
    seeAllLink: {
      display: 'block',
      marginTop: '20px',
      textDecoration: 'none',
      fontWeight: 'bold',
      color: '#890608',
      fontSize: '14px'
    },
    loading: {
      width: "100%",
      minHeight: "40vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
  },
  adContainer: {
    margin: "25px auto",
    padding: "18px 15px",
    background: "#FFF9F5",
    borderRadius: 10,
    textAlign: "center",
    border: "1px solid #F0E6DF",
    boxShadow: "0 3px 6px rgba(139, 86, 27, 0.08)",
    [theme.breakpoints.down("sm")]: {
        padding: "15px 10px",
        margin: "20px auto",
    },
    },
    topAd: {
    borderTop: "4px solid #890608",
    background: "#FFF5F5",
    marginTop: 0,
    marginBottom: 30,
    [theme.breakpoints.down("sm")]: {
        borderWidth: 3,
        marginTop: 10,
    },
    },
    midAd: {
    borderLeft: "4px solid #EA7606",
    background: "#FFF8F0",
    margin: "30px auto",
    [theme.breakpoints.down("sm")]: {
        borderWidth: 3,
    },
    },
    bottomAd: {
    borderBottom: "4px solid #B5551B",
    background: "#FFF6F0",
    marginTop: 40,
    marginBottom: 30,
    [theme.breakpoints.down("sm")]: {
        borderWidth: 3,
    },
    },
    postCommentsAd: {
    borderTop: "4px solid #B5551B",
    borderBottom: "4px solid #B5551B",
    background: "#FFF6F0",
    margin: "40px 0",
    [theme.breakpoints.down("sm")]: {
        borderWidth: 3,
    },
    
},
  })
);

export interface HomeSectionsResponse {
  latestArticles: IArticleBlog[];
  categories: Record<string, IArticleBlog[]>;
  themes: Record<string, IArticleBlog[]>;
}

// Slider Auto Settings
const sliderAutoSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToScroll: 1,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false, // Hide previous and next buttons
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const BlogHome = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const blogService = new BlogService();
  const [latestArticles, setLatestArticles] = useState<IArticleBlog[]>([]);
  const [carRentalArticles, setCarRentalArticles] = useState<IArticleBlog[]>([]);
  const [africaArticles, setAfricaArticles] = useState<IArticleBlog[]>([]);
  const [lodgingTips, setLodgingTips] = useState<IArticleBlog[]>([]);
  const [rentalManagementArticles, setRentalManagementArticles] = useState<IArticleBlog[]>([]);
  const [localActivitiesArticles, setLocalActivitiesArticles] = useState<IArticleBlog[]>([]);
  const [financialAdviceArticles, setFinancialAdviceArticles] = useState<IArticleBlog[]>([]);
  const [realEstateArticles, setRealEstateArticles] = useState<IArticleBlog[]>([]);
  const [canMarocArticles, setCanMarocArticles] = useState<IArticleBlog[]>([]);
  const [culturesAfricainesArticles, setCulturesAfricainesArticles] = useState<IArticleBlog[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [articles, setArticles] = useState<Record<string, IArticleBlog[]>>({});
  const [loadingSections, setLoadingSections] = useState<Record<string, boolean>>({});
  const [sections, setSections] = useState<HomeSectionsResponse>({
    latestArticles: [],
    categories: {},
    themes: {}
});



  const fetchArticles = async (key: string, fetchFn: () => Promise<IArticleBlog[]>) => {
    try {
      const data = await fetchFn();
      setArticles((prev) => ({ ...prev, [key]: data }));
    } catch (error) {
      console.error(`Error fetching ${key}:`, error);
    }
  };

  useEffect(() => {
    const CACHE_KEY = 'homeSections';
    const CACHE_TTL = 300000; // 5 minutes

    const loadData = async () => {
        const cached = localStorage.getItem(CACHE_KEY);
        if (cached) {
            const { data, timestamp } = JSON.parse(cached);
            if (Date.now() - timestamp < CACHE_TTL) {
                setSections(data);
                setLoading(false);
                return;
            }
        }

        try {
            const data = await blogService.getHomeSections();
            setSections(data);
            localStorage.setItem(CACHE_KEY, JSON.stringify({
                data,
                timestamp: Date.now()
            }));
        } catch (error) {
            console.error('Error loading sections:', error);
        }
        setLoading(false);
    };

    loadData();
}, []);

/*
  useEffect(() => {
    const loadAllArticles = async () => {
      await Promise.all([
        fetchArticles("latestArticles", () => blogService.getArticlesByTheme("actualites")),
        fetchArticles("carRentalArticles", () => blogService.getArticlesByTheme("louer-un-vehicule")),
        fetchArticles("africaArticles", () => blogService.getArticlesByCategory("decouvrir-lafrique")),
        fetchArticles("lodgingTips", () => blogService.getArticlesByTheme("reserver-un-logement")),
        fetchArticles("rentalManagementArticles", () => blogService.getArticlesByTheme("gerer-un-logement-meuble")),
        fetchArticles("culturesAfricainesArticles", () =>
          blogService.getArticlesByCategory("cultures-africaines")
        ),
        fetchArticles("canMarocArticles", () => blogService.getArticlesByTheme("can-maroc-2025")),
      ]);
      setLoading(false);
    };
    loadAllArticles();
  }, []);

  */

  // Helper function to sort articles by publication date
  const sortArticlesByDate = (articles: IArticleBlog[]) => {
    return articles.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
  };
/*
  useEffect(() => {
    const fetchArticlesByCategory = async (categorySlug: string, setArticles: React.Dispatch<React.SetStateAction<IArticleBlog[]>>) => {
      try {
        const articles = await blogService.getArticlesByCategory(categorySlug);
        if (articles) {
          setArticles(articles);
        }
      } catch (error) {
        console.error(`Error fetching articles for "${categorySlug}" category:`, error);
      }
    };

    const fetchArticlesByTheme = async (themeSlug: string, setArticles: React.Dispatch<React.SetStateAction<IArticleBlog[]>>) => {
      try {
        const articles = await blogService.getArticlesByTheme(themeSlug);
        if (articles) {
          setArticles(articles);
        }
      } catch (error) {
        console.error(`Error fetching articles for "${themeSlug}" category:`, error);
      }
    };

    // Run all fetches simultaneously and only update loading state when they’re all complete
  const loadAllArticles = async () => {
    await Promise.all([
      fetchArticlesByTheme("actualites", setLatestArticles),
      fetchArticlesByTheme("louer-un-vehicule", setCarRentalArticles),
      fetchArticlesByCategory("decouvrir-lafrique", setAfricaArticles),
      fetchArticlesByCategory("cultures-africaines", setCulturesAfricainesArticles),
      fetchArticlesByTheme("reserver-un-logement", setLodgingTips),
      fetchArticlesByTheme("gerer-un-logement-meuble", setRentalManagementArticles),
      //fetchArticlesByCategory("culture", setLocalActivitiesArticles),
      //fetchArticlesByCategory("actualites", setFinancialAdviceArticles),
      //fetchArticlesByCategory("actualites", setRealEstateArticles),
      fetchArticlesByTheme("can-maroc-2025", setCanMarocArticles),
    ]);
    setLoading(false);
  };

  loadAllArticles();
  }, []); */

  const sliderAutoSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToScroll: 1,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

    // Helper component for section rendering
  const SectionRenderer: React.FC<{
    title: string;
    articles: IArticleBlog[];
    link: string;
    classes: any;
  }> = ({ title, articles, link, classes }) => (
    <section className={classes.section}>
      <h2 className={classes.sectionTitle}>{title}</h2>
      <div className={classes.articleCards}>
        {articles?.slice(0, 3).map((article) => (
          <ErrorBoundary key={article._id}>
            <Suspense fallback={<PropagateLoader color="#36D7B7" size={10} />}>
              <Article article={article} showIntroduction={false} layout="column" />
            </Suspense>
          </ErrorBoundary>
        ))}
      </div>
      <div className={classes.btnContainer}>
        <Link to={link} className={classes.btn}>
          {t('bloghome.see-all')}
        </Link>
      </div>
    </section>
  );

  const currentUrl = typeof window !== "undefined" ? window.location.href : "https://afriqpnb.com/blog";


  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Blog",
    "name": t("bloghome.metatitle"), 
    "description": t("bloghome.notre-mission"), 
    "url": currentUrl, 
    "image": {
        "@type": "ImageObject",
        "url": "https://afriqpnb.com/api/images/properties/sunset-bloghome.jpeg", 
        "height": "300",
        "width": "300"
    },
    "author": {
        "@type": "Organization",
        "name": "AfriqPnB"
    },
    "publisher": {
        "@type": "Organization",
        "name": "AfriqPnB",
        "logo": {
            "@type": "ImageObject",
            "url": "https://afriqpnb.com/logo.png",
            "width": "60",
            "height": "60"
        }
    },
    "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": currentUrl 
    },
  };


  return (
    <>
      <Helmet>
          <title>{t("bloghome.metatitle")}</title>
          <meta
              name="description"
              content={t("bloghome.notre-mission")}
              data-rh="true"
          />
          <meta property="og:title" content={t("bloghome.metatitle")} data-rh="true" />
          <meta
              property="og:description"
              content={t("bloghome.notre-mission")}
              data-rh="true"
          />
          <meta
              property="og:url"
              content="https://afriqpnb.com/blog"
              data-rh="true"
          />
          <meta name="keywords" content={t("bloghome.keywords")}data-rh="true" />
          <meta
              property="og:site_name"
              content="AfriqPnB"
              data-rh="true"
          />
          <meta
              property="og:type"
              content="website"
              data-rh="true"
          />
          <meta
              name="author"
              content="AfriqPnB"
              data-rh="true"
          />
          <meta
              property="og:image"
              content="https://afriqpnb.com/api/images/properties/sunset-bloghome.jpeg"
              data-rh="true"
          />
          <meta
              property="og:image:secure_url"
              content="https://afriqpnb.com/api/images/properties/sunset-bloghome.jpeg"
              data-rh="true"
          />
          <meta
              property="og:image:type"
              content="image/jpeg"
              data-rh="true"
          />
          <meta
              property="og:image:width"
              content="300"
              data-rh="true"
          />
          <meta
              property="og:image:height"
              content="300"
              data-rh="true"
          />
          <meta
              property="og:image:alt"
              content={t("bloghome.altSunset")}  data-rh="true"
          />
          <link rel="canonical" href={window.location.href} />

          {/* Twitter Metadata */}
          <meta name="twitter:card" content="summary_large_image" data-rh="true" />
            <meta name="twitter:title" content={t("bloghome.metatitle")} data-rh="true" />
            <meta
                name="twitter:description"
                content={t("bloghome.notre-mission")}
                data-rh="true"
            />
            <meta
                name="twitter:image"
                content="https://afriqpnb.com/api/images/properties/sunset-bloghome.jpeg"
                data-rh="true"
            />

          <script type="application/ld+json">
              {JSON.stringify(schemaMarkup)}
          </script>
          
      </Helmet>
      <Suspense fallback={<div className={classes.loading}><PropagateLoader color="#36D7B7" size={15}/></div>}>
        <ErrorBoundary>
          <NavbarBlog />
        </ErrorBoundary>
        
        {loading ? (
          <div className={classes.loading}>
            <PropagateLoader color="#36D7B7" size={15} />
          </div>
        ) : (
          <Grid container justifyContent="center" className={classes.topContainer}>     
            <Grid item xs={12} md={10}>
              {/* Main Featured Section */}
              <section>
                <h1 className={classes.h1Title}>{t('bloghome.welcome')}</h1>
                <h2 className={classes.h2Title}>{t('bloghome.notre-mission')}</h2>
                <div className={classes.sliderContainer}>
                  <Slider {...sliderAutoSettings}>
                    {sections.latestArticles?.map((article: IArticleBlog) => (
                      <ErrorBoundary key={article._id}>
                        <Suspense fallback={<PropagateLoader color="#36D7B7" size={10} />}>
                          <BackgroundImageCard article={article} showIntroduction={false} />
                        </Suspense>
                      </ErrorBoundary>
                    ))}
                  </Slider>
                </div>
                <div className={classes.btnContainer}>
                  <Link to="/blog/rubrique/actualites" className={classes.btn}>
                    {t('bloghome.see-all')}
                  </Link>
                </div>
              </section>

              {/* Category Sections */}
              <LazySection sectionId="discover-africa">
                <SectionRenderer 
                  title={t('bloghome.discover-africa')}
                  articles={sections.categories['decouvrir-lafrique']}
                  link="/blog/rubrique/decouvrir-lafrique"
                  classes={classes}
                />
              </LazySection>

              <LazySection sectionId="cultures-africaines">
                <SectionRenderer
                  title={t('bloghome.cultures-africaines')}
                  articles={sections.categories['cultures-africaines']}
                  link="/blog/rubrique/cultures-africaines"
                  classes={classes}
                />
              </LazySection>

              {/* Theme Sections */}
              <LazySection sectionId="can-maroc-2025">
                <SectionRenderer
                  title={t('bloghome.can-maroc-2025')}
                  articles={sections.themes['can-maroc-2025']}
                  link="/blog/rubrique/Footbal/can-maroc-2025"
                  classes={classes}
                />
              </LazySection>

              <LazySection sectionId="lodging-tips">
                <SectionRenderer
                  title={t('bloghome.lodging-tips')}
                  articles={sections.themes['reserver-un-logement']}
                  link="/blog/rubrique/conseils-dexperts/reserver-un-logement"
                  classes={classes}
                />
              </LazySection>

              <LazySection sectionId="car-rentals">
              <SectionRenderer
                title={t('bloghome.car-rentals')}
                articles={sections.themes['louer-un-vehicule']}
                link="/blog/rubrique/conseils-dexperts/louer-un-vehicule"
                classes={classes}
              />
              </LazySection>

              <LazySection sectionId="seasonal-rental">
              <SectionRenderer
                title={t('bloghome.seasonal-rental')}
                articles={sections.themes['gerer-un-logement-meuble']}
                link="/blog/rubrique/conseils-dexperts/gerer-un-logement-meuble"
                classes={classes}
              />
              </LazySection>

              {/* AdSense Placeholders 
              <div className={`${classes.adContainer} ${classes.topAd}`}>
                {/* <AdSenseAd slotId="2800722459" /> }
              </div>
              <div className={`${classes.adContainer} ${classes.midAd}`}>
                {/* <AdSenseAd slotId="5972948186" /> }
              </div>
              <div className={`${classes.adContainer} ${classes.bottomAd}`}>
                {/* <AdSenseAd slotId="7669905759" /> } 
              </div> */}
            </Grid> 
          </Grid>
        )}
      </Suspense>
    </>
  );
};

export default BlogHome;
